$(function() {

	// Vars
	var $form = $('form#survey-edit'),
		$addQuestion = $form.find('#survey-edit-add-question'),
		$questions = $('#survey-edit-questions'),
		$template = $('#survey-edit-question-template');

	// Add question
	$addQuestion.click(function() {
		addQuestionFromTemplate();
	});

	// Add question from template
	function addQuestionFromTemplate() {

		var $html = $template.find('> div').clone(),
			timestamp = uuidv4();

		$html.find('[data-name="question_ids"]').val(timestamp);
		$html.find('[data-name="question"]').attr('name', 'question_' + timestamp);
		$html.find('[data-name="dimension_id"]').attr('name', 'dimension_id_' + timestamp);
		$html.find('[data-name="sort_order"]').attr('name', 'sort_order_' + timestamp);

		$questions.append($html);
		refreshNumbering();
		var $question = $questions.find('.survey-edit-question').last();
		$question.find('input[type="text"], textarea').focus();
		$(window).scrollTop($question.offset().top);
	}

	// Sort
	function refreshSorting() {

		// Questions
		$('#survey-edit-questions.ui-sortable').sortable('destroy');
		$('#survey-edit-questions').sortable({
			items: '.survey-edit-question',
			stop:refreshNumbering,
			handle: 'i.sort'
		});

	}
	refreshSorting();

	// Refresh numbering
	function refreshNumbering() {

		$questions.find('.survey-edit-question').each(function(index) {

			$(this).find('.total').html(index + 1);
			$(this).find('[data-name="sort_order"]').val(index + 1);

		});

	}

	// Remove question
	$questions.on('click', '.remove', function() {
		
		if (confirm('Remove this question?')) {
			$(this).parents('.survey-edit-question').remove();
			if (!$questions.find('.survey-edit-question').length) {
				addQuestionFromTemplate();
			}
			refreshNumbering();
		}

		return false;
	});

	// Generate UUID
	function uuidv4() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

});